import { createContext } from 'react';

export const ScreenChangesContext = createContext<string | null>(null);
